// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * The transform decodes the payload itself.
 */
export class TransformDecode implements flatbuffers.IUnpackableObject<TransformDecodeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TransformDecode {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTransformDecode(
    bb: flatbuffers.ByteBuffer,
    obj?: TransformDecode,
  ): TransformDecode {
    return (obj || new TransformDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTransformDecode(
    bb: flatbuffers.ByteBuffer,
    obj?: TransformDecode,
  ): TransformDecode {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TransformDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static startTransformDecode(builder: flatbuffers.Builder) {
    builder.startObject(0);
  }

  static endTransformDecode(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createTransformDecode(builder: flatbuffers.Builder): flatbuffers.Offset {
    TransformDecode.startTransformDecode(builder);
    return TransformDecode.endTransformDecode(builder);
  }

  unpack(): TransformDecodeT {
    return new TransformDecodeT();
  }

  unpackTo(_o: TransformDecodeT): void {}

  unpackFields(...fields: string[]): TransformDecodeT {
    const t = new TransformDecodeT();
    const fieldSet = new Set(fields);
    return t;
  }
}

export class TransformDecodeT implements flatbuffers.IGeneratedObject {
  constructor() {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return TransformDecode.createTransformDecode(builder);
  }

  clone(): TransformDecodeT {
    const obj = new TransformDecodeT();
    return obj;
  }

  equals(other: TransformDecodeT): boolean {
    return true;
  }
}

export function verifyTransformDecode(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
  } finally {
    verifier.popDepth();
  }
}
